"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WatchMember = void 0;
const lodash_1 = require("lodash");
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const styled_components_1 = __importStar(require("styled-components"));
const GlobalStateProvider_1 = require("../../../../../GlobalStateProvider");
const common_1 = require("../../../../../common");
const server_1 = require("../../../../../server");
const classes_1 = require("../../../../base/classes");
const popup_1 = require("../../../../base/popup");
/* ────────────────────────────────────────────────────────────────────────────
 * 다시보기 일부 공개 — 참여자 추가 팝업
 *
 * SMS 발송 화면의 [수신자 목록] 팝업(ChoiceMemberList)과 같은 방식:
 *  - 클래스 멤버 전체를 한 번에 받아 두고(클라이언트 보관), 검색·페이징은 클라이언트에서 처리
 *  - 성명 또는 아이디로 검색(부분 일치, 대소문자 무시)
 *  - 검색·페이지 이동 시 체크 상태 유지(Table isKeepChecked) — 팝업을 열 때 이미 등록된 참여자는 미리 체크
 *  - 여러 명 선택 후 [확인] 한 번으로 일괄 반영(부모 members 교체)
 * 컬럼: 성명 | 아이디 | 참여권한 (모바일은 "성명(아이디) / 참여권한" 한 줄)
 * ──────────────────────────────────────────────────────────────────────────── */
const PAGE_SIZE = 10;
const WatchMemberStyled = styled_components_1.default.div `
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	gap: 16px;

	.watch-member-header {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		gap: 12px;
		flex-wrap: wrap;

		.count {
			display: flex;
			align-items: center;
			gap: 10px;
			color: var(--color-black, #101010);
			font-family: var(--h5-font-family, 'Noto Sans KR', sans-serif);
			font-size: var(--h5-font-size, 16px);
			line-height: var(--h5-line-height, 24px);
			font-weight: var(--h5-font-weight, 700);
			white-space: nowrap;

			.selected {
				color: var(--color-tur, #3ab2bf);
			}
		}

		.search-wrap {
			display: flex;
			align-items: center;
			gap: 8px;

			.search-hint {
				color: var(--color-grey-l, #83868a);
				font-size: 12px;
				line-height: 20px;
				white-space: nowrap;
			}

			.search-bar input {
				width: unset;
				font-size: var(--b6-font-size, 12px);
				line-height: var(--b6-line-height, 20px);
				letter-spacing: var(--b6-letter-spacing, -0.02em);
				font-weight: var(--b6-font-weight, 400);
			}

			.search-bar svg {
				width: 12px;
				height: 12px;
			}
		}
	}

	.popup-list-008 {
		border-style: solid;
		border-color: var(--color-grey-c, #e6e8ed);
		border-width: 0px 0px 1px 0px;
		display: flex;
		flex-direction: column;
		gap: 0px;
		align-items: flex-start;
		justify-content: flex-start;
		flex-shrink: 0;
		position: relative;
		overflow: hidden;
		height: unset;
	}

	.table-header {
		background: var(--color-silver, #f3f4f8);
		border-style: solid;
		border-color: var(--color-grey-w, #b6bac0);
		border-width: 1px 0px 0px 0px;
		padding: 10px 16px 10px 16px;
		display: flex;
		flex-direction: row;
		gap: 20px;
		align-items: center;
		justify-content: flex-start;
		flex-shrink: 0;
		position: relative;

		p {
			color: var(--color-black, #101010);
			text-align: left;
			font-family: var(--b4-font-family, 'Noto Sans KR', sans-serif);
			font-size: var(--b4-font-size, 14px);
			line-height: var(--b4-line-height, 28px);
			letter-spacing: var(--b4-letter-spacing, -0.02em);
			font-weight: var(--b4-font-weight, 400);
			position: relative;
		}
	}

	.item {
		border-style: solid;
		border-color: var(--color-silver, #f3f4f8);
		border-width: 0px 0px 1px 0px;
		padding: 12px 16px 12px 16px;
		display: flex;
		flex-direction: row;
		gap: 20px;
		align-items: center;
		justify-content: flex-start;
		flex-shrink: 0;
		position: relative;

		span,
		p {
			color: var(--color-black, #101010);
			text-align: left;
			font-family: var(--b4-font-family, 'Noto Sans KR', sans-serif);
			font-size: var(--b4-font-size, 14px);
			line-height: var(--b4-line-height, 28px);
			letter-spacing: var(--b4-letter-spacing, -0.02em);
			font-weight: var(--b4-font-weight, 400);
		}

		.idf {
			color: var(--color-grey-l, #83868a);
		}
	}

	.empty-members {
		width: 100%;
		padding: 32px 0;
		text-align: center;
		color: var(--color-grey-l, #83868a);
		font-size: var(--b4-font-size, 14px);
	}

	${props => props.$isMobile &&
    (0, styled_components_1.css) `
			.watch-member-header {
				flex-direction: column;
				align-items: stretch;

				.search-wrap {
					width: 100%;

					.search-bar {
						flex: 1;
					}
				}
			}

			.table-item-wrap {
				.body-item {
					width: unset;
				}
			}

			.item {
				gap: 8px;

				span,
				p {
					font-size: 12px;
					line-height: 150%;
				}
			}
		`}
`;
const normalize = (value) => (value ?? '').toString().trim().toLowerCase();
exports.WatchMember = react_1.default.memo(({ members, setMembers, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const classesId = (0, classes_1.getClassesId)();
    const { isMobile } = (0, GlobalStateProvider_1.useGlobalState)();
    const [page, setPage] = (0, react_1.useState)(0);
    const [allMembers, setAllMembers] = (0, react_1.useState)([]);
    const [checkList, setCheckList] = (0, react_1.useState)([]);
    const [keyword, setKeyword] = (0, react_1.useState)('');
    // 팝업을 열 때 이미 등록된 참여자를 미리 체크. 마운트 시 1회만 계산해야 한다 —
    // Table 은 defaultCheckList 참조가 바뀔 때마다 체크 상태를 이 값으로 되돌린다.
    const defaultCheckList = (0, react_1.useMemo)(() => (members ?? []).map(member => member.id), []);
    // 클래스 멤버 전체 조회(offset/limit 없음) — 검색·페이징은 클라이언트에서
    const { data, refetch } = (0, server_1.useMemberInfo)({ class_id: classesId });
    const refetchList = (0, react_1.useMemo)(() => (0, lodash_1.throttle)(() => refetch(), 1000, { leading: true, trailing: false }), []);
    (0, react_1.useEffect)(() => {
        refetchList();
    }, []);
    (0, react_1.useEffect)(() => {
        if (data) {
            const { items, total_count } = data;
            if (total_count > 0 && Array.isArray(items)) {
                setAllMembers(items);
                return;
            }
        }
        setAllMembers([]);
    }, [data]);
    // 성명 또는 아이디 부분 일치(대소문자 무시)
    const filteredMembers = (0, react_1.useMemo)(() => {
        const search = normalize(keyword);
        if (!search)
            return allMembers;
        return allMembers.filter(member => normalize(member.nickname).includes(search) ||
            normalize(member.identifier).includes(search));
    }, [allMembers, keyword]);
    const pagedMembers = (0, react_1.useMemo)(() => filteredMembers.slice(page * PAGE_SIZE, page * PAGE_SIZE + PAGE_SIZE), [filteredMembers, page]);
    // 검색 결과가 줄어 현재 페이지가 비면 마지막 페이지로
    (0, react_1.useEffect)(() => {
        const maxPage = Math.max(0, Math.ceil(filteredMembers.length / PAGE_SIZE) - 1);
        if (page > maxPage)
            setPage(maxPage);
    }, [filteredMembers.length, page]);
    const { headTitleList, tableReadDataKeys } = (0, react_1.useMemo)(() => {
        const headTitleList = isMobile
            ? [{ title: 'nameId', space: 1, sort: false }]
            : [
                { title: 'name', space: 2, sort: false },
                { title: 'id', space: 2, sort: false },
                { title: 'participant', space: 1, sort: false },
            ];
        const tableReadDataKeys = [
            { title: 'nickname', space: 2, sort: false },
            { title: 'identifier', space: 2, sort: false },
            { title: 'level_name', space: 1, sort: false },
        ];
        return { headTitleList, tableReadDataKeys };
    }, [isMobile]);
    // SearchBar → { keyword: string | undefined }
    const handlerFilterList = (filter) => {
        const values = Object.values(filter);
        const next = values.length > 0 && typeof values[0] === 'string' ? values[0] : '';
        setKeyword(next);
        setPage(0);
    };
    const handlerMoreData = (nextPage) => {
        setPage(nextPage);
    };
    const closePopup = () => {
        APP.eventManager.publish(popup_1.TOGGLE_POPUP);
    };
    // 선택한 학생 전체를 한 번에 반영 — 검색·페이지에 걸쳐 체크된 id 를 전부 모은다
    const onSubmit = () => {
        const checked = new Set(checkList);
        const picked = allMembers
            .filter(member => checked.has(member.id))
            .map(member => ({ id: member.id, name: member.nickname, idf: member.identifier }));
        // 목록에서 사라진(퇴반 등) 기존 참여자가 체크된 채 남아 있으면 그대로 유지
        const pickedIds = new Set(picked.map(member => member.id));
        const kept = (members ?? []).filter(member => checked.has(member.id) && !pickedIds.has(member.id));
        setMembers([...picked, ...kept]);
        closePopup();
    };
    const renderItem = (item, styles) => {
        if (isMobile) {
            return (react_1.default.createElement("div", { className: "body-item", style: { flex: 1, ...styles?.bodyItem } },
                react_1.default.createElement("p", { className: "overText2" },
                    item.nickname,
                    item.identifier && react_1.default.createElement("span", { className: "idf" },
                        "(",
                        item.identifier,
                        ")"),
                    item.level_name && ` / ${item.level_name}`)));
        }
        return tableReadDataKeys.map(headItem => (react_1.default.createElement("div", { key: headItem.title, className: "body-item", style: { flex: headItem.space, ...styles?.bodyItem } },
            react_1.default.createElement("span", { className: `overText2 ${headItem.title === 'identifier' ? 'idf' : ''}` }, item[headItem.title] || '-'))));
    };
    const renderEmpty = (0, react_1.useMemo)(() => filteredMembers.length === 0 && (react_1.default.createElement("div", { className: "empty-members" }, allMembers.length === 0
        ? '클래스에 참여자가 없습니다.'
        : '검색 결과가 없습니다. 성명 또는 아이디를 다시 확인해주세요.')), [filteredMembers.length, allMembers.length]);
    return (react_1.default.createElement(WatchMemberStyled, { "$isMobile": isMobile },
        react_1.default.createElement("div", { className: "watch-member-header" },
            react_1.default.createElement("div", { className: "count" },
                react_1.default.createElement("span", null,
                    "\uC804\uCCB4 ",
                    allMembers.length,
                    "\uBA85"),
                react_1.default.createElement("span", { className: "selected" },
                    "\uC120\uD0DD ",
                    checkList.length,
                    "\uBA85")),
            react_1.default.createElement("div", { className: "search-wrap" },
                !isMobile && react_1.default.createElement("span", { className: "search-hint" }, "\uC131\uBA85 \uB610\uB294 \uC544\uC774\uB514"),
                react_1.default.createElement(common_1.SearchBar, { className: `${!isMobile ? 'search-bar-qna' : 'search-bar-mobile'}`, filterData: "keyword", handlerFilterList: handlerFilterList, isMember: false, defaultSearchContent: keyword }))),
        react_1.default.createElement(common_1.Table, { className: "popup-list-008", showCheckBox: true, 
            // isKeepChecked: 페이지·검색이 바뀌어도 체크 유지 / isSMS: 그 상태에서도 defaultCheckList(기존 참여자) 적용
            // accumulateAllCheck: 헤더 전체 체크도 누적(2페이지 전체 체크 시 1페이지 선택 유지)
            isKeepChecked: true, isSMS: true, accumulateAllCheck: true, defaultCheckList: defaultCheckList, forceShowheader: true, isInfinite: false, data: pagedMembers, totalCount: filteredMembers.length, page: page, showCount: PAGE_SIZE, sortDefault: "id", headTitleList: headTitleList, renderItem: renderItem, renderEmpty: renderEmpty, handlerCheckList: setCheckList, handlerMoreData: handlerMoreData }),
        react_1.default.createElement("div", { className: "btn-container" },
            react_1.default.createElement(common_1.Button, { className: `btn_white ${isMobile ? ' sm' : 'xmd'}`, text: "common.cancel", onClick: closePopup }),
            react_1.default.createElement(common_1.Button, { className: `btn_default ${isMobile ? ' sm' : 'xmd'}`, text: t('common.okay'), onClick: onSubmit }))));
});
